export default {"src":"/_next/static/image/public/images/ic_settings_grey_vertical_menu.d69d853ccc59f16eb2836a78258674f1.svg","height":20,"width":20};